import request from './request';

const http = {
  get(url, params, config = {}) {
    const requestConfig = {
      method: 'get',
      url,
      ...config, // 合并传入的配置
    };
    if (params) requestConfig.params = params;
    return request(requestConfig);
  },
  post(url, params, config = {}) {
    const requestConfig = {
      method: 'post',
      url,
      ...config, // 合并传入的配置
    };
    if (params) requestConfig.data = params;
    return request(requestConfig);
  },
  put(url, params, config = {}) {
    const requestConfig = {
      method: 'put',
      url,
      ...config, // 合并传入的配置
    };
    if (params) requestConfig.data = params;
    return request(requestConfig);
  },
  delete(url, params, config = {}) {
    const requestConfig = {
      method: 'delete',
      url,
      ...config, // 合并传入的配置
    };
    if (params) requestConfig.params = params;
    return request(requestConfig);
  },
};

export default http;
